<template>
  <div class="ai rt60">
    <div>
      <banner :child-data="fdata"></banner>
      <div class="anchor container">
        <a @click="scrollTo(0)">功能介绍</a>
        <a @click="scrollTo(1)">功能演示</a>
        <a @click="scrollTo(2)">应用案例</a>
      </div>
      <div id="ai-main">
        <div class="anchor_contianer">
          <div class="ai-sec container " data-ani="">
            <div class="develop-title">
              <span class="line"></span>
              <span class="title-text">功能介绍</span>
              <span class="line"></span>
            </div>
            <div>
              <b-card>
                <b-media>
                  <template v-slot:aside>
                    <b-img
                      src="https://ai.bdstatic.com/file/589EDB965B3A4E37AA714915ACCDACEB"
                      width="64"
                      alt="placeholder"
                    ></b-img>
                  </template>
                  <h5 class="mt-0">识别车辆品牌型号</h5>
                  <p>检测图片中的主体车辆位置，识别车辆品牌型号（如宝马X3）、年份、颜色信息，可识别3000款常见车型（小汽车为主）</p>
                </b-media>

                <b-media>
                  <template v-slot:aside>
                    <b-img
                      src="https://ai.bdstatic.com/file/589EDB965B3A4E37AA714915ACCDACEB"
                      width="64"
                      alt="placeholder"
                    ></b-img>
                  </template>
                  <h5 class="mt-0">识别车辆品牌型号</h5>
                  <p>检测图片中的主体车辆位置，识别车辆品牌型号（如宝马X3）、年份、颜色信息，可识别3000款常见车型（小汽车为主）</p>
                </b-media>
              </b-card>
            </div>
          </div>
          <div class="ai-function " data-ani="">
            <div class="container">
              <div class="develop-title">
                <span class="line"></span>
                <span class="title-text">功能演示</span>
                <span class="line"></span>
              </div>
              <div class="function">
                <div class="fun_left">
                  <div class="funL_top">
                    <div class="tech-recognition-scan"></div>
                    <div class="tips">原始图片</div>
                    <div class="imgShow">
                      <li class="imgSec">
                        <img :src="img0" />
                      </li>
                    </div>
                    <div class="abBtn">
                      <b-button variant="outline-primary" @click="triggerFile(0)">本地上传</b-button>
                      <input
                        type="file"
                        class="upload"
                        @change="addImg($event,0)"
                        ref="inputer0"
                        id="file0"
                        accept="image/png, image/jpeg, image/gif, image/jpg"
                      />
                    </div>
                  </div>
                  <div class="funL_Bot">
                    <div @click="imgupload('../../img/adas.jpg')">
                      <b-img
                        src="https://ai.bdstatic.com/file/589EDB965B3A4E37AA714915ACCDACEB"
                        width="64"
                        alt="placeholder"
                      ></b-img>
                    </div>
                    <div>
                      <b-img
                        src="https://ai.bdstatic.com/file/589EDB965B3A4E37AA714915ACCDACEB"
                        width="64"
                        alt="placeholder"
                      ></b-img>
                    </div>
                    <div>
                      <b-img
                        src="https://ai.bdstatic.com/file/589EDB965B3A4E37AA714915ACCDACEB"
                        width="64"
                        alt="placeholder"
                      ></b-img>
                    </div>
                    <div>
                      <b-img
                        src="https://ai.bdstatic.com/file/589EDB965B3A4E37AA714915ACCDACEB"
                        width="64"
                        alt="placeholder"
                      ></b-img>
                    </div>
                    <div>
                      <b-img
                        src="https://ai.bdstatic.com/file/589EDB965B3A4E37AA714915ACCDACEB"
                        width="64"
                        alt="placeholder"
                      ></b-img>
                    </div>
                  </div>
                </div>
                <div class="fun_right">
                  <div role="tablist">
                    <b-card no-body class="mb-1">
                      <b-card-header header-tag="header" class="p-1" role="tab">
                        <b-button block href="#" v-b-toggle.accordion-1 variant="info">Request</b-button>
                      </b-card-header>
                      <b-collapse id="accordion-1" visible accordion="my-accordion" role="tabpanel">
                        <b-card-body>
                          <b-card-text>Request内容</b-card-text>
                        </b-card-body>
                      </b-collapse>
                    </b-card>

                    <b-card no-body class="mb-1">
                      <b-card-header header-tag="header" class="p-1" role="tab">
                        <b-button block href="#" v-b-toggle.accordion-2 variant="info">Response</b-button>
                      </b-card-header>
                      <b-collapse id="accordion-2" accordion="my-accordion" role="tabpanel">
                        <b-card-body>
                          <b-card-text>Response内容</b-card-text>
                        </b-card-body>
                      </b-collapse>
                    </b-card>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="ai-advantage " data-ani="">
            <div class="container">
              <div class="develop-title">
                <span class="line"></span>
                <span class="title-text">应用案例</span>
                <span class="line"></span>
              </div>
              <div>
                <b-card no-body>
                  <b-tabs pills card vertical>
                    <b-tab title="拍照识车" active>
                      <b-card-text>
                        <div class="car_top">
                          <div class="top_le">
                            <h3>拍照识车</h3>
                            <p>根据拍摄照片，快速识别图片中车辆的品牌型号，提供针对性的信息或服务，可用于相册管理、图片分类打标签、电子汽车说明书、一键拍照租车等场景</p>
                            <p>
                              相关产品:
                              <a href="carDetect">车型识别</a>
                            </p>
                          </div>
                          <div class="top_ri">
                            <img
                              src="https://ai.bdstatic.com/file/79144295AD884BCF8F98781D53141BB7"
                              alt
                            />
                          </div>
                        </div>
                        <div class="car_bot">
                          <h3>合作案例</h3>
                          <div class="logo">
                            <span>QQ</span>
                            <span>QQ</span>
                            <span>QQ</span>
                          </div>
                        </div>
                      </b-card-text>
                    </b-tab>
                    <b-tab title="违章停车检测">
                      <b-card-text>
                        <div class="car_top">
                          <div class="top_le">
                            <h3>拍照识车</h3>
                            <p>根据拍摄照片，快速识别图片中车辆的品牌型号，提供针对性的信息或服务，可用于相册管理、图片分类打标签、电子汽车说明书、一键拍照租车等场景</p>
                            <p>
                              相关产品:
                              <a href="carDetect">车型识别</a>
                            </p>
                          </div>
                          <div class="top_ri">
                            <img
                              src="https://ai.bdstatic.com/file/79144295AD884BCF8F98781D53141BB7"
                              alt
                            />
                          </div>
                        </div>
                        <div class="car_bot">
                          <h3>合作案例</h3>
                          <div class="logo">
                            <span>QQ</span>
                            <span>QQ</span>
                            <span>QQ</span>
                          </div>
                        </div>
                      </b-card-text>
                    </b-tab>
                    <b-tab title="智能卡口">
                      <b-card-text>
                        <div class="car_top">
                          <div class="top_le">
                            <h3>拍照识车</h3>
                            <p>根据拍摄照片，快速识别图片中车辆的品牌型号，提供针对性的信息或服务，可用于相册管理、图片分类打标签、电子汽车说明书、一键拍照租车等场景</p>
                            <p>
                              相关产品:
                              <a href="carDetect">车型识别</a>
                            </p>
                          </div>
                          <div class="top_ri">
                            <img
                              src="https://ai.bdstatic.com/file/79144295AD884BCF8F98781D53141BB7"
                              alt
                            />
                          </div>
                        </div>
                        <div class="car_bot">
                          <h3>合作案例</h3>
                          <div class="logo">
                            <span>QQ</span>
                            <span>QQ</span>
                            <span>QQ</span>
                          </div>
                        </div>
                      </b-card-text>
                    </b-tab>
                    <b-tab title="路况分析">
                      <b-card-text>
                        <div class="car_top">
                          <div class="top_le">
                            <h3>拍照识车</h3>
                            <p>根据拍摄照片，快速识别图片中车辆的品牌型号，提供针对性的信息或服务，可用于相册管理、图片分类打标签、电子汽车说明书、一键拍照租车等场景</p>
                            <p>
                              相关产品:
                              <a href="carDetect">车型识别</a>
                            </p>
                          </div>
                          <div class="top_ri">
                            <img
                              src="https://ai.bdstatic.com/file/79144295AD884BCF8F98781D53141BB7"
                              alt
                            />
                          </div>
                        </div>
                        <div class="car_bot">
                          <h3>合作案例</h3>
                          <div class="logo">
                            <span>QQ</span>
                            <span>QQ</span>
                            <span>QQ</span>
                          </div>
                        </div>
                      </b-card-text>
                    </b-tab>
                    <b-tab title="智能定损">
                      <b-card-text>
                        <div class="car_top">
                          <div class="top_le">
                            <h3>拍照识车</h3>
                            <p>根据拍摄照片，快速识别图片中车辆的品牌型号，提供针对性的信息或服务，可用于相册管理、图片分类打标签、电子汽车说明书、一键拍照租车等场景</p>
                            <p>
                              相关产品:
                              <a href="carDetect">车型识别</a>
                            </p>
                          </div>
                          <div class="top_ri">
                            <img
                              src="https://ai.bdstatic.com/file/79144295AD884BCF8F98781D53141BB7"
                              alt
                            />
                          </div>
                        </div>
                        <div class="car_bot">
                          <h3>合作案例</h3>
                          <div class="logo">
                            <span>QQ</span>
                            <span>QQ</span>
                            <span>QQ</span>
                          </div>
                        </div>
                      </b-card-text>
                    </b-tab>
                  </b-tabs>
                </b-card>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import topNav from "../components/top";
import banner from "../components/banner";
import footerBot from "../components/footerBot";
import { mapMutations } from "vuex";
export default {
  name: "about",
  data() {
    return {
      fdata: {
        h1: "车辆检测",
        h2: "",
        style: {
          background: "lightgray"
        }
      },
      formData: new FormData(),
      img0: {},
      menu: 1
    };
  },
  components: {
    topNav,
    banner,
    footerBot
  },
  methods: {
    addActive(val) {
      this.menu = val;
    },
    triggerFile(val) {
      var myfile = document.getElementById("file" + val);
      myfile.click();
    },
    addImg(event, val) {
      console.log(event.target.files[0]);
      var inputDOM = event.target.files[0];
      console.log(inputDOM);
      var reader = new FileReader();
      var that = this;
      reader.readAsDataURL(inputDOM);
      reader.onload = function(e) {
        console.log(this.result);
        that["img" + val] = this.result;
      };
    },
    imgupload(src) {
      var img = new Image();
      img.setAttribute("crossorigin", "anonymous");
      img.src = src;
      var that = this;
      img.onload = () => {
        var cvs = document.createElement("canvas");
        var ctx = cvs.getContext("2d");
        cvs.width = img.width;
        cvs.height = img.height;
        ctx.drawImage(img, 0, 0, cvs.width, cvs.height);
        cvs.toBlob(blob => {
          var form = new FormData();
          form.append("file", blob);
          // console.log(that.img0);
          // console.log(form.get("file"));
          var reader = new FileReader();
          reader.readAsDataURL(form.get("file"));
          reader.onload = function(e) {
            that.img0 = this.result;
          };
        });
      };
    },
    changeUrl(url) {
      function upload(url) {}
      console.log(this.img0);
      console.log(url);
    },
    onScroll() {
      // 获取所有锚点元素
      const navContents = document.querySelectorAll(".anchor_contianer>div"); // 所有锚点元素的 offsetTop
      const offsetTopArr = [];
      navContents.forEach(item => {
        offsetTopArr.push(item.offsetTop);
      }); // 获取当前文档流的 scrollTop
      const scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop; // 定义当前点亮的导航下标
      let navIndex = 0;
      for (let n = 0; n < offsetTopArr.length; n++) {
        // 如果 scrollTop 大于等于第n个元素的 offsetTop 则说明 n-1 的内容已经完全不可见 // 那么此时导航索引就应该是n了
        if (scrollTop >= offsetTopArr[n]) {
          navIndex = n;
        }
      }
      this.active = navIndex;
    },
    scrollTo(index) {
      // 获取目标的 offsetTop // css选择器是从 1 开始计数，我们是从 0 开始，所以要 +1
      const targetOffsetTop = document.querySelector(
        `.anchor_contianer>div:nth-child(${index + 1})`
      ).offsetTop; // 获取当前 offsetTop
      let scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop; // 定义一次跳 50 个像素，数字越大跳得越快，但是会有掉帧得感觉，步子迈大了会扯到蛋
      const STEP = 50; // 判断是往下滑还是往上滑
      if (scrollTop > targetOffsetTop) {
        // 往上滑
        smoothUp();
      } else {
        // 往下滑
        smoothDown();
      } // 定义往下滑函数
      function smoothDown() {
        // 如果当前 scrollTop 小于 targetOffsetTop 说明视口还没滑到指定位置
        if (scrollTop < targetOffsetTop) {
          // 如果和目标相差距离大于等于 STEP 就跳 STEP // 否则直接跳到目标点，目标是为了防止跳过了。
          if (targetOffsetTop - scrollTop >= STEP) {
            scrollTop += STEP;
          } else {
            scrollTop = targetOffsetTop;
          }
          document.body.scrollTop = scrollTop;
          document.documentElement.scrollTop = scrollTop; // 关于 requestAnimationFrame 可以自己查一下，在这种场景下，相比 setInterval 性价比更高
          requestAnimationFrame(smoothDown);
        }
      } // 定义往上滑函数
      function smoothUp() {
        if (scrollTop > targetOffsetTop) {
          if (scrollTop - targetOffsetTop >= STEP) {
            scrollTop -= STEP;
          } else {
            scrollTop = targetOffsetTop;
          }
          document.body.scrollTop = scrollTop;
          document.documentElement.scrollTop = scrollTop;
          requestAnimationFrame(smoothUp);
        }
      }
    },
    ...mapMutations(["editMenu"])
  },
  mounted() {
    this.editMenu("about");
    window.addEventListener("scroll", this.onScroll, false);
  },
  destroy() {
    // 必须移除监听器，不然当该vue组件被销毁了，监听器还在就会出错
    window.removeEventListener("scroll", this.onScroll);
  }
};
</script>

<style scoped>
.ai-advantage {
  padding: 60px;
}
#headerwrap h2 {
  font-size: 20px;
  text-align: left;
}
blockquote {
  border: none;
}
#navbar-main {
  /* height: 144px; */
}
#about-main {
  padding-bottom: 30px;
}
#headerwrap {
  /* background: url(../../public/img/about/gyks_banner@3x.jpg) no-repeat center top; */
  display: flex;
  align-items: center;
  justify-content: center;
}
#headerwrap h1 {
  margin-top: 0;
}

#headerwrap h2 {
  color: white;
  margin-bottom: 0;
}

#ai-main .img-banner {
  height: 380px;
  width: 100%;
  /* background: url(img/about/gyks_banner@3x.jpg) no-repeat 100% center; */
  background-size: 100% 100%;
  box-sizing: border-box;
}

#ai-main .img-banner h3 {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 40px;
}

@media screen and (max-width: 480px) {
  #ai-main .img-banner {
    height: 170px;
    width: 100%;
    background: url(../../public/img/about/gyks_banner@3x.jpg) no-repeat center;
    background-size: 100% 100%;
  }
}
#ai-main .company-info {
  /* padding: 20px 0px; */
  box-sizing: border-box;
}
.company-develop {
  padding-top: 40px;
}
.ai-function {
  height: 700px;
  background: aliceblue;
}
.ai-function .function {
  display: flex;
  height: 550px;
  background: antiquewhite;
}
.ai-function .function .fun_left {
  flex: 3;
}
.ai-function .function .fun_left .funL_top {
  height: 450px;
  width: 100%;
  background: beige;
  position: relative;
}
.ai-function .function .fun_left .funL_Bot {
  height: 100px;
  width: 100%;
  background: azure;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.ai-function .function .fun_left .funL_Bot div {
  flex: 1;
  margin: 20px;
  padding: 20px;
  color: white;
  /* background: black; */
  cursor: pointer;
}
.ai-function .function .fun_right {
  flex: 1;
}
#ai-main .info-title,
#ai-main .develop-title {
  text-align: center;
  margin-bottom: 30px;
  margin-top: 20px;
}
#ai-main .info-main {
  display: flex;
  flex-direction: column;
  /* align-items: ; */
}
#ai-main .info-title .title-text,
#ai-main .develop-title .title-text {
  font-size: 30px;
}

.tab-content {
  background-color: #fff;
  border: 1px solid #ddd;
  border-top: 0;
  padding: 15px 15px 5px;
  box-sizing: border-box;
}

.well {
  box-shadow: none;
  background-color: rgba(0, 0, 0, 0.05);
}

#headerwrap p {
  font-weight: 300;
  text-align: center;
  letter-spacing: 1px;
}
.btn-outline-primary {
  color: black;
  border-color: #ccc;
}
.btn-outline-primary:hover {
  color: white;
}
.advantage {
  display: flex;
}
.advantage_sec {
  flex: 1;
  padding: 0px 40px;
}
.advantage_sec .p20 {
  padding-right: 30px;
  text-align: left;
}
.advantage_sec .p20 h3 {
  font-size: 18px;
}
.advantage_sec .p20 p {
  font-size: 14px;
}
.card-deck:nth-child(n + 1) {
  margin-top: 30px;
}
.card-text {
  text-align: left;
}
.card {
  border: none;
  background: unset;
}
.ai-scene {
  padding: 60px;
}
.ai-scene .card {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.ai-scene .card .card-body {
  text-align: left;
}

.ai-scene .card img {
  width: 50%;
}
#ai-main .card-body {
  display: flex;
}
#ai-main .card-body .media {
  flex: 1;
}
#ai-main .card-body .media .media-body {
  text-align: left;
  padding: 0 20px;
}

@media screen and (max-width: 480px) {
  .ai-function .function .fun_left .funL_top {
    height: 200px;
  }
  .function .imgShow {
    height: auto !important;
  }
  .function .imgShow img {
    width: 100%;
    height: auto;
  }
  .container {
    padding: 10px 20px 20px;
  }
  .ai-scene .card {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .ai-scene .card .card-body {
    text-align: left;

  }

  .ai-scene .card img {
    width: 50%;
  }
  #ai-main .card-body {
    display: flex;
    flex-wrap: wrap;
    padding: 0 16px !important
  }
  #ai-main .card-body .media {
    flex: unset;
  }
  #ai-main .card-body .media .media-body {
    text-align: left;
    padding: 0 20px;
  }
  .ai-function {
    height: auto;
  }
  .ai-function .function {
    height: auto;
    flex-wrap: wrap;
  }
  .ai-function .function .fun_left {
    width: 100%
  }
  .ai-function .function .fun_left .funL_Bot div{
    margin: 0;
    padding: 0
  }
  .ai-advantage {
    padding: 0;
  }
}
.ai-parter {
  background: cadetblue;
  padding: 60px;
}
.partner-sec {
  display: flex;
  align-items: center;
  justify-content: center;
}
.partner-sec > div {
  padding: 20px;
  flex: 1;
  background: white;
  margin-right: 20px;
}
.ai-parter .develop-title .title-text {
  color: white;
}
.ai-sec {
  padding: 25px 0px 40px;
}
.fileGroup {
  display: flex;
  justify-content: space-around;
  height: 350px;
}

.imgBottom {
  position: absolute;
  bottom: 0;
}

.fileGroup > div {
  width: 48%;
  position: relative;
}

.fileGroup .json_right {
  border: 1px solid lightgray;
}

.function .imgShow {
  width: 100%;
  height: 450px;
  /* border: 1px solid lightgray; */
}
.function .imgShow img {
  /* width: 100%; */
  height: 100%;
}
.function .json_right {
  background: aliceblue;
}
#file0 {
  display: none;
}
.function .tips {
  position: absolute;
  left: 0;
  top: 0;
  padding: 5px 10px;
  background-color: #e6fafd;
  font-size: 14px;
  color: gray;
}
.btn-group {
  margin-bottom: 20px;
}
.imgSec {
  width: 100%;
  height: 100%;
  overflow: hidden;
  list-style-type: none;
}
.compare {
  width: 20%;
  margin-top: 30px;
}

.anchor {
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
}
.anchor a {
  color: black;
  padding: 8px;
  cursor: pointer;
}
a:hover {
  text-decoration: none;
  font-weight: bold;
  border-bottom: 2px solid black;
}
.car_top {
  display: flex;
  border-bottom: 1px solid #ccc;
  padding-bottom: 30px;
}
.car_top .top_le {
  flex: 3;
  margin-right: 50px;
}
.car_top .top_ri {
  flex: 1;
}
@media screen and (max-width: 480px) {
  .col-auto {
    width: 100% !important;
  }
  .car_top .top_le {
    flex: unset;
    margin-right: 0px;
  }
  .car_top .top_ri {
    flex: unset;
  }
}
.car_top .top_ri img {
  width: 100%;
}
.car_bot {
  margin-top: 20px;
}
.car_bot div {
  display: flex;
  align-items: center;
  /* justify-content: space-evenly; */
  margin-top: 20px;
}
.car_bot div span {
  /* display: inline-block; */
  width: 80px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 20px;
  background-color: white;
}
.ai-finegrained {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  min-width: 219px;
  padding: 17px 12px;
  background-color: #0073eb;
}
.ai-finegrained-title {
  margin-bottom: 14px;
  font-size: 16px;
  color: #fff;
}
.ai-finegrained-item {
  margin-bottom: 17px;
  color: #fff;
  font-size: 0;
}
.ai-finegrained-item-degree,
.ai-finegrained-item-length,
.ai-finegrained-item-name {
  display: table-cell;
  height: 32px;
  vertical-align: middle;
  font-size: 14px;
  color: #fff;
}
.ai-finegrained-item-length {
  width: 89px;
  height: 4px;
  padding-left: 30px;
  background-color: transparent;
}
.ai-finegrained-item-length-inner {
  min-width: 1px;
  height: 4px;
  background-color: #fff;
  -webkit-transition: width 1s linear;
  -moz-transition: width 1s linear;
  transition: width 1s linear;
}
.ai-summary {
  position: absolute;
  right: 0;
  top: 0;
  z-index: 1;
}
@-webkit-keyframes scan {
  0% {
    height: 0;
  }
  to {
    opacity: 0;
    height: 100%;
  }
}
@-moz-keyframes scan {
  0% {
    height: 0;
  }
  to {
    opacity: 0;
    height: 100%;
  }
}
@keyframes scan {
  0% {
    height: 0;
  }
  to {
    opacity: 0;
    height: 100%;
  }
}
.tech-recognition {
  background: #f4f5f7;
}
.tech-recognition-content {
  position: relative;
  width: 100%;
  height: 654px;
}
.tech-img-content {
  width: 840px;
  height: 100%;
  float: left;
}
.tech-recognition-scan {
  position: absolute;
  z-index: 7;
  top: 0;
  left: 0;
  width: 100%;
  border-bottom: 3px solid #3e88f1;
  -webkit-animation: scan 1.2s infinite;
  -moz-animation: scan 1.2s infinite;
  animation: scan 1.2s infinite;
  background: -webkit-gradient(
    linear,
    left top,
    left bottom,
    from(transparent),
    to(#3e88f1)
  );
  background: -webkit-linear-gradient(top, transparent, #3e88f1);
  background: -moz-linear-gradient(top, transparent, #3e88f1);
  background: linear-gradient(180deg, transparent, #3e88f1);
}
.abBtn {
  position: absolute;
  bottom: 0;
  height: 50px;
  background: rgba(0, 0, 0, 0.1);
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-right: 20px;
  padding-right: 34px;
}
.rt60 {
  position: relative;
  top: -60px;
    margin-bottom: -60px;
}
</style>
